import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { ReactNode } from 'react';

interface Props extends BaseProps {
  children?: string | ReactNode;
  className?: string;
  color?: string;
  label?: string | null;
  size?: StandardSizes;
}

const Button = ({
  className,
  children = null,
  size = 'sm',
  color,
  label,
  ...rest
}: Props) => {
  const sizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6 children:active:-translate-x-[4px]',
    lg: 'w-8 h-8 children:active:-translate-x-[2px]',
  };

  return (
    <button
      style={{ background: color }}
      className={clsx(
        className,
        baseButtonClass,
        'flex rounded-full items-center justify-center align-middle text-center',
        sizes[size],
        { 'scale-75': window.devicePixelRatio > 1 }
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export const Circle = (props: Props) => {
  const { className, label, ...rest } = props;

  if (props.label)
    return (
      <div className={clsx(className, 'relative flex flex-col items-center')}>
        <p className="absolute text-[0.55rem] -top-2 mb-2 tracking-wider text-white whitespace-nowrap text-center mb-[2px]">
          {label}
        </p>
        <Button className="mt-2" {...rest} />
      </div>
    );
  return <Button className={className} {...rest} />;
};
